import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PurchaseOrderSetupModel } from '@app/models/system-settings';

@Injectable()
export class PurchaseOrderSetupService {
	private readonly endpointBase = '/api/site-po-setups';

	constructor(private readonly http: HttpClient) {}

	getSites(): Observable<any> {
		return this.http.get(`${this.endpointBase}/sites`);
	}

	getBySiteId(siteId?: number): Observable<any> {
		return this.http.get(`${this.endpointBase}/${siteId}`);
	}

	saveSiteSetup(model: PurchaseOrderSetupModel, siteId?: number): Observable<any> {
		return this.http.post(`${this.endpointBase}/${siteId}`, model);
	}

	getEmailsForActiveUsers(): Observable<any> {
		return this.http.post('/api/user/list', { active: true });
	}

	getPurchaseOrderPreview(copyNumber: number, siteId?: number): Observable<any> {
		return this.http.get(`${this.endpointBase}/${siteId}/preview`, { params: { copyNumber: copyNumber.toString() } });
	}
}
